// Title-case a proper name. Words are separated by whitespace, underscore, or
// hyphen. The first character of each word is upper-cased; remaining
// characters are lower-cased. Original separators are preserved so
// "Smith-Jones" keeps its hyphen and "van der berg" stays multi-word.
// Mirrors the backend's clean_proper_name() (legal_ops/utils/name_cleaning.py)
// so the typed-and-saved values look identical on both sides.

const TOKEN_SPLIT_RE = /([\s_\-]+)/;

export const cleanProperName = (value) => {
  if (value == null) return value;
  if (typeof value !== 'string') return value;
  const stripped = value.trim();
  if (!stripped) return '';
  const parts = stripped.split(TOKEN_SPLIT_RE);
  return parts
    .map((part) => {
      if (!part) return part;
      if (/^[\s_\-]+$/.test(part)) return part;
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    })
    .join('');
};
